import React, { useState } from 'react'
import {Plus, Minus} from 'lucide-react'
import { beansStories } from './beansContent'

/**
 * BeansStoriesV2
 * 12 篇 Coffee Bean Guide 極簡手風琴
 * 預設全收，視覺只露出襯線標題清單
 * SEO 完整保留（DOM 內含完整內文，可被爬蟲抓取）
 */
const BeansStoriesV2: React.FC<{ lang: 'zh' | 'en' }> = ({ lang }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const isZh = lang === 'zh'

  return (
    <section className="bg-[#f5f1ea] border-t border-black/5">
      <div className="mx-auto max-w-[1100px] px-5 md:px-10 py-24 md:py-32">
        <div className="mb-16 md:mb-20">
          <div
            className="text-[10px] uppercase text-black/40 mb-4"
            style={{ letterSpacing: '0.3em' }}
          >
            {isZh ? '咖啡豆指南' : 'Coffee Bean Guide'}
          </div>
          <h2
            className="text-3xl md:text-5xl text-black/90"
            style={{
              fontFamily: '"EB Garamond", "Noto Serif TC", serif',
              fontWeight: 300,
              letterSpacing: '-0.01em',
            }}
          >
            {isZh ? 'Stories' : 'Stories'}
          </h2>
          <div className="mt-2 text-sm text-black/50" style={{ fontWeight: 300 }}>
            {isZh ? '十二則關於咖啡豆的事' : 'Twelve notes about coffee beans'}
          </div>
        </div>

        <div className="divide-y divide-black/10 border-t border-b border-black/10">
          {beansStories.map((story, i) => {
            const open = openIndex === i
            return (
              <article key={i}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left hover:opacity-70 transition-opacity duration-300"
                >
                  <h3
                    className="text-base md:text-lg text-black/85"
                    style={{
                      fontFamily: '"EB Garamond", "Noto Serif TC", serif',
                      fontWeight: 300,
                      letterSpacing: '0.01em',
                    }}
                  >
                    <span className="inline-block w-10 text-black/30 text-xs align-middle mr-3">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    {story.title}
                  </h3>
                  <span className="shrink-0 text-black/50">
                    {open ? <Minus size={16} strokeWidth={1.2} /> : <Plus size={16} strokeWidth={1.2} />}
                  </span>
                </button>

                {/* SEO 友善：內容永遠存在 DOM，僅由 max-height 控制視覺折疊 */}
                <div
                  className={`overflow-hidden transition-[max-height] duration-500 ease-out ${
                    open ? 'max-h-[600px]' : 'max-h-0'
                  }`}
                >
                  <div
                    className="pl-13 md:pl-16 pr-2 pb-8 text-sm md:text-base text-black/65 guide-speakable"
                    style={{ fontWeight: 300, lineHeight: 2, letterSpacing: '0.02em' }}
                  >
                    {story.content}
                  </div>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default BeansStoriesV2
